import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enCommon from "locales/en/common.json";
import enSubscriptions from "locales/en/subscriptions.json";
import enOrder from "locales/en/order.json";
import enPayment from "locales/en/payment.json";

import frCommon from "locales/fr/common.json";
import frSubscriptions from "locales/fr/subscriptions.json";
import frOrder from "locales/fr/order.json";
import frPayment from "locales/fr/payment.json";

export const SUPPORTED_LANGUAGES = ["en", "fr"] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const resources = {
  en: {
    common: enCommon,
    subscriptions: enSubscriptions,
    order: enOrder,
    payment: enPayment,
  },
  fr: {
    common: frCommon,
    subscriptions: frSubscriptions,
    order: frOrder,
    payment: frPayment,
  },
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: [...SUPPORTED_LANGUAGES],
    defaultNS: "common",
    ns: ["common", "subscriptions", "order", "payment"],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  });

i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng;
  }
});

if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.language;
}

export default i18n;

/** Map UI language to Intl / number formatting locale. */
export function getNumberLocale(language?: string): string {
  const lng = (language || i18n.language || "en").split("-")[0];
  return lng === "fr" ? "fr-FR" : "en-NG";
}
